import PropTypes from 'prop-types';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const SearchWindow = (props) => {
  return (
    <TextField
      placeholder='氏名、社員番号'
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchOutlinedIcon sx={{ color: 'primary.main' }} />
          </InputAdornment>
        ),
        style: {
          height: '44px',
          backgroundColor: 'white',
        },
      }}
      onChange={(event) => {
        props.setSearchText(event.target.value);
      }}
    />
  );
};

export default SearchWindow;

SearchWindow.propTypes = {
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
};
